<template>
  <global-search />
</template>

<script>
import GlobalSearch from '@/_components/GlobalSearch.vue';

export default {
  name: 'CardMiscSearch',
  components: {
    GlobalSearch,
  },
};
</script>
